import { useEffect } from 'react'
import ReconnectingWebSocket from 'reconnecting-websocket'
import authStore from '../store/authStore'
import mapStore from '../store/mapStore'
import { getUserIPaddress, processGibiMessage } from './webSocketHelper'

export const WebSocket = () => {
    useEffect(() => {
        void getUserIPaddress().then(() => console.log('got ws uuid'))
    }, [])

    const userToken: string = authStore(s => s.token)
    const userIP: string = authStore(s => s.userIP)

    useEffect(() => {
        if (!userToken || !userIP) return

        const url = import.meta.env.VITE_WEBSOCKET_URL + `/${userIP}`
        const rws = new ReconnectingWebSocket(url)

        const onOpen = () => {
            rws.send(JSON.stringify({ type: 'login', token: userToken }))
        }

        const onClose = () => {
            mapStore.getState().setWebSocketConnected(false)
        }

        const onError = (error: any) => {
            console.log('websocket error', error)
            mapStore.getState().setWebSocketConnected(false)
        }

        const onMessage = (event: MessageEvent) => {
            try {
                let message = event?.data ? JSON.parse(event.data) : {}
                if (message.status === 'ok' || message.type === 'echo') {
                    mapStore.getState().setWebSocketConnected(true)
                    return
                }
                processGibiMessage(message)
            } catch (e) {
                console.log('web socket', e)
            }
        }

        rws.addEventListener('open', onOpen)
        rws.addEventListener('close', onClose)
        rws.addEventListener('error', onError)
        rws.addEventListener('message', onMessage)

        return () => {
            rws.removeEventListener('open', onOpen)
            rws.removeEventListener('close', onClose)
            rws.removeEventListener('error', onError)
            rws.removeEventListener('message', onMessage)
            rws.close()
        }
    }, [userToken, userIP])

    return <div/>
}
